import {color, ColorHelper} from 'csx';
import {
    Chart0Color,
    Chart1Color,
    Chart4Color,
    Chart5Color,
    Chart6Color,
    Chart7Color,
    Chart8Color,
    Chart9Color,
    Chart2Color,
    Chart3Color,
    BlackColor,
    WhiteColor,
} from '../styles/colors';

export const DIAGRAM_COLORS: ColorHelper[] = [
    color(Chart0Color),
    color(Chart1Color),
    color(Chart2Color),
    color(Chart3Color),
    color(Chart4Color),
    color(Chart5Color),
    color(Chart6Color),
    color(Chart7Color),
    color(Chart8Color),
    color(Chart9Color),
];

export const getReadableTextColor = (backgroundColor: string | ColorHelper): string => {
    let backgroundColorHelper: ColorHelper;
    if (typeof backgroundColor === 'string') {
        if (backgroundColor === 'transparent') {
            return BlackColor;
        }
        backgroundColorHelper = color(backgroundColor);
    } else {
        backgroundColorHelper = backgroundColor;
    }

    if (backgroundColorHelper.red() * 0.299 + +backgroundColorHelper.green() * 0.587 + +backgroundColorHelper.blue() * 0.114 > 186) {
        return BlackColor;
    }
    return WhiteColor;
};

export const colorToString = (col: ColorHelper | undefined, invert?: boolean) => {
    const col2 = col ? col : DIAGRAM_COLORS[0];
    return invert ? col2.invert().toString() : col2.toString();
};



// WEBPACK FOOTER //
// ./src/utility/ColorUtils.ts